<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2022-10-01</p>
    <div class="content">
      <!-- 第一段内容：签约仪式介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>

      <!-- 第二段内容：公司与实验室介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>

      <!-- 图片部分 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url">
          <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
        </div>
      </div>

      <!-- 第三段内容：签约与合作方向 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'lanzhoudaxue');
  return newsItem || {};
});

</script>

<style scoped lang="scss">
.page-container {
  overflow: auto; 
}

.content-section {
  margin-bottom: 20px;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}
</style> 